module.exports = __webpack_public_path__ + "static/media/lamoderna_cisneoro_.5c2e158f.png";